(function () {
  if (window.SpotmateTracking && typeof window.SpotmateTracking.push === 'function') return;

  var seen = Object.create(null);
  var contextKeys = ['page_type', 'page_path', 'content_group', 'language'];
  var piiKey = /(^|_)(email|phone|address|first_name|last_name)($|_)/i;

  function pageContext() {
    var layer = window.dataLayer || [];
    var result = {};

    for (var index = layer.length - 1; index >= 0; index -= 1) {
      var entry = layer[index];
      if (!entry || entry.event !== 'spotmate_page_context') continue;

      contextKeys.forEach(function (key) {
        if (entry[key] !== undefined && entry[key] !== null && entry[key] !== '') {
          result[key] = entry[key];
        }
      });
      break;
    }

    return result;
  }

  function sanitize(value, depth) {
    if (depth > 5 || value === undefined || typeof value === 'function') return undefined;
    if (value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;

    if (Array.isArray(value)) {
      return value.map(function (item) {
        return sanitize(item, depth + 1);
      }).filter(function (item) {
        return item !== undefined;
      });
    }

    if (Object.prototype.toString.call(value) !== '[object Object]') return String(value);

    return Object.keys(value).reduce(function (result, key) {
      if (piiKey.test(key)) return result;
      var cleanValue = sanitize(value[key], depth + 1);
      if (cleanValue !== undefined) result[key] = cleanValue;
      return result;
    }, {});
  }

  function queryParams() {
    try {
      return new window.URLSearchParams(window.location.search);
    } catch (error) {
      return { has: function () { return false; }, get: function () { return null; } };
    }
  }

  function environment() {
    var config = window.SpotmateTrackingConfig || {};
    if (config.environment) return config.environment;
    if (window.Shopify && window.Shopify.designMode) return 'development';
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') return 'preview';
    if (queryParams().has('preview_theme_id')) return 'preview';
    return 'production';
  }

  function debugMode() {
    var config = window.SpotmateTrackingConfig || {};
    if (config.debug === true) return true;
    return queryParams().get('spotmate_debug') === '1';
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'sm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function push(eventName, parameters, options) {
    if (!/^[a-z][a-z0-9_]*$/.test(eventName)) {
      throw new TypeError('Spotmate tracking event names must use snake_case.');
    }

    var settings = options || {};
    var now = Date.now();
    var dedupeWindow = Number(settings.dedupeWindowMs) || 2000;
    var dedupeKey = settings.dedupeKey ? eventName + '|' + String(settings.dedupeKey) : '';

    if (dedupeKey && seen[dedupeKey] && now - seen[dedupeKey] < dedupeWindow) return null;
    if (dedupeKey) seen[dedupeKey] = now;

    if (Object.keys(seen).length > 100) {
      Object.keys(seen).forEach(function (key) {
        if (now - seen[key] > 300000) delete seen[key];
      });
    }

    var payload = Object.assign({}, pageContext(), sanitize(parameters || {}, 0), {
      event: eventName,
      event_id: settings.eventId || eventId(),
      event_timestamp: new Date(now).toISOString(),
      environment: environment(),
      debug_mode: debugMode(),
      event_source: 'theme'
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.spotmateGtmPush === 'function') {
      window.spotmateGtmPush(payload);
    }
    return payload.event_id;
  }

  window.SpotmateTracking = {
    version: '1.0.0',
    push: push
  };
})();
